import { useState, useEffect } from "react";
import { ReactComponent as Resend } from "../../iconColor/resend.svg";

const CustomTimer = ({ initialTime, onResend }: any) => {
  const [timer, setTimer] = useState(initialTime);
  const [countdown, setCountdown] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (countdown) {
      clearInterval(countdown);
    }
    const newCountdown = setInterval(() => {
      setTimer((prevTimer: any) => {
        if (prevTimer === 0) {
          clearInterval(newCountdown);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    setCountdown(newCountdown);

    return () => clearInterval(newCountdown);
  }, [initialTime]);

  const handleResendClick = () => {
    if (countdown) {
      clearInterval(countdown);
    }
    onResend();
    setTimer(initialTime);
    const newCountdown = setInterval(() => {
      setTimer((prevTimer: any) => {
        if (prevTimer === 0) {
          clearInterval(newCountdown);
          return 0;
        }
        return prevTimer - 1;
      });
    }, 1000);
    setCountdown(newCountdown);
  };

  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  return (
    <div>
      {timer === 0 ? (
        <div
          className="flex items-center justify-center gap-2 cursor-pointer"
          onClick={handleResendClick}
        >
          <span className="text-primary-600 text-Title/14/Regular">
            ارسال مجدد
          </span>
          <Resend />
        </div>
      ) : (
        <div>
          <span>ارسال مجدد کد بعد از </span>
          <span>{minutes.toString().padStart(2, "0")}</span>:
          <span>{seconds.toString().padStart(2, "0")}</span>
        </div>
      )}
    </div>
  );
};

export default CustomTimer;
